<div class="size-detector">
  <div *ngFor="let s of sizes" class="{{s.css + ' ' + (prefix + s.id) }}">{{s.name}}</div>
</div>
<ng-content></ng-content>
